var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLyrecoProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd7a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24214,
    stopColor: "#fbc953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#fbbc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d31d42"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.96448,36.8147l-5.6098-3.23883-18.48676,10.67346,6.79382,3.9223c.36646.21155.81793.21155,1.18439,0l16.11835-9.30554c.78961-.45587.78961-1.59552,0-2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.54382,38.86615l5.13184,2.96283,18.48712-10.67334-6.31641-3.64673c-.36646-.21161-.81793-.21161-1.18439,0l-16.11816,9.30585c-.78961.45587-.78961,1.59552,0,2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.67133,43.4646v18.68835c0,.41119.21942.7912.57556.99677l16.18445,9.34412c.76733.44305,1.72656-.11072,1.72656-.99677v-18.68817c0-.41125-.21942-.7912-.5755-.99683l-6.87177-3.96753v9.87964l-4.19208-2.17682v-10.12317l-5.12067-2.95642c-.76733-.44305-1.72656.11072-1.72656.99683Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.32867,60.20569l-2.716-4.77106c-1.74017,12.77344-19.40033,15.36951-26.46631,16.90564,20.27362-2.91827,28.2608-7.67902,29.18231-12.13458Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.35071,50.87341c-20.27203,2.91791-28.25922,7.67987-29.17987,12.13269l2.71576,4.77228c1.7395-12.77216,19.39996-15.36981,26.46411-16.90497Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyrecoProductsScraper);
export default __webpack_public_path__ + "static/media/lyreco-products-scraper.c5547faea0f70f9e79f453191f3c76e1.svg";
export { ForwardRef as ReactComponent };